import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ListGroup, ListGroupItem, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../store/actions/actions';
import { getDataTableSetting, getDataTable, getAppMenu } from '../../helper/Service';

import HeaderRun from './Header.run'
import config from '../../helper/Config';
import swal from 'sweetalert';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSetting: {},
            setupAddress: {},
            reportAddress: {},
            inventoryAddress: {},
            topMenu : []
        }
    };

    componentDidMount = async() => {
        HeaderRun();
        this.fetchSetting();
        await this.fetchTopMenu();
        
    }

    fetchTopMenu = async () => {
        const response = await getAppMenu('TopMenu');
        
        if (response.status == 200) {
            console.log(response.data);    
            this.setState({
                topMenu : response.data
            })
        }

        
    }

    toggleUserblock = e => {
        e.preventDefault();
        this.props.actions.toggleSetting('showUserBlock');
    }

    toggleOffsidebar = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('offsidebarOpen');
    }

    toggleCollapsed = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('isCollapsed');
        this.resize()
    }

    toggleAside = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('asideToggled');
    }

    resize() {
        // all IE friendly dispatchEvent
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
        // modern dispatchEvent way
        // window.dispatchEvent(new Event('resize'));
    }

    fetchSetting = async () => {
        let param = {
            "Take": 9999,
            "filters": [
                {
                    "ColumnName": "AppSettingKeys",
                    "ColumnValue": 'EquipWeb_SetupURL,InventoryWeb_ReportURL,InventoryWeb_SetupURL',
                    "Operator": "EQ"
                }
            ]
        };

        try {

            const resultData = await getDataTable(param, 'SP_Multiple_Appsetting');
            const responseData = resultData.data[0];
            if (resultData.resultCode == 200) {
                // let setup = result.find(x => x.appSettingKey == "EquipWeb_SetupURL")
                // let report = result.find(x => x.appSettingKey == "InventoryWeb_ReportURL")
                // let inventory = result.find(x => x.appSettingKey == "InventoryWeb_SetupURL")

                this.setState({
                    dataSetting: resultData.data,
                    setupAddress: responseData.equipWeb_SetupURL,
                    reportAddress: responseData.inventoryWeb_ReportURL,
                    inventoryAddress: responseData.inventoryWeb_SetupURL
                })
            }
        } catch (error) {
            console.log(error)
        }
    };

    handleLogout = e => {
        swal({
            title: "Are you sure want to logout?",
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: {
                    text: 'Logout',
                    value: true,
                    visible: true,
                    className: "bg-danger",
                    closeModal: true
                }
            }
        })
            .then((logout) => {
                if (logout) {
                    this.props.actions.updateUserInfo({
                        userInfo: {},
                        token: {}
                    });
                    localStorage.removeItem(`/${config.BASE_PATH}`);
                    localStorage.removeItem(`/${config.BASE_PATH.toLowerCase()}_token`);
                    let landingPage = `${config.WEB_URL?.toLocaleLowerCase()}`;
                    landingPage = landingPage.replace('/setup', '');
                    // window.location.pathname = `${config.BASE_URL}/login`;
                    window.location.href = landingPage;
                }
            });

        e.preventDefault()
    }

    goToHome = () => {
        let pg = `${config.WEB_URL?.toLocaleLowerCase()}`;
        console.log(pg);
        window.location.href = pg;
        
    }

    formatRoute= (value) => {
        if (value.startsWith('http')) {
            return value;
        } else if(value.startsWith('/')) {
            let url = `${config.WEB_URL}/new/${value}`
            return url;
        } else  {
            return value;
        }
    }

    render() {
        return (
            <header className="topnavbar-wrapper">
                { /* START Top Navbar */}
                <nav className="navbar topnavbar">

                    { /* START Left navbar */}
                    <ul className="navbar-nav mr-auto flex-row">
                        <li className="nav-item">
                            { /* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
                            <a href="" className="nav-link d-none d-md-block d-lg-block d-xl-block" onClick={this.toggleCollapsed}>
                                <em className="fas fa-bars"></em>
                            </a>
                            { /* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                            <a href="" className="nav-link d-md-none" onClick={this.toggleAside}>
                                <em className="fas fa-bars"></em>
                            </a>
                        </li>
                        <li className="nav-item">
                            {/* <Trans i18nKey={'sidebar.nav.product.CATEGORY'}></Trans> */}
                            <div className='wrapper-page-title'>
                                &#09;<h4 onClick={() => this.goToHome()} className='page-title' style={{ color: 'white', fontFamily: 'system-ui' }}></h4>
                            </div>

                        </li>

                    </ul>
                    { /* END Left navbar */}

                    { /* START Right Navbar */}
                    <ul className="navbar-nav flex-row">
                        { /* START Alert menu */}
                        <UncontrolledDropdown nav inNavbar className="dropdown-list">
                            <DropdownToggle nav className="dropdown-toggle-nocaret" style={{ padding: '0px 0px 0px 0px' }}>
                                <Button color="info" style={{ display: 'flex', textAlign: 'left' }} >
                                    <div className='image-profile'>
                                        <img className="img-fluid" src="img/user.png" alt="User Logo" style={{ height: '40px' }} />
                                    </div>
                                    <div className='info-profile'>
                                        <span><b>{this.props.user.role}</b></span><br />
                                        <span>{this.props.user.userName} </span>
                                    </div>
                                </Button>
                            </DropdownToggle>
                            { /* START Dropdown menu */}
                            <DropdownMenu right className="dropdown-menu-right animated flipInX">
                                <DropdownItem>
                                    { /* START list group */}
                                    <ListGroup>
                                        <ListGroupItem action tag="div" href="" >
                                            <Link to={'/profil'} style={{ textDecoration: 'none', color: '#555' }}>
                                                <span className="d-flex align-items-center">
                                                    <em className="fa fa-user"></em>&nbsp;&nbsp;&nbsp;
                                                    <span className="text-sm">Profile</span>
                                                </span>
                                            </Link>
                                        </ListGroupItem>
                                        {/* <ListGroupItem action tag="a" href="" onClick={e => e.preventDefault()}>
                                            <span className="d-flex align-items-center">
                                                <em className="fa fa-bell"></em>&nbsp;&nbsp;&nbsp;
                                                <span className="text-sm">Notifications</span>
                                                <span className="badge badge-danger ml-auto">14</span>
                                            </span>
                                        </ListGroupItem> */}
                                        {/* <ListGroupItem action tag="div" href="" >
                                            <a href={`${window.location.origin}/${config.BASE_PATH}`} target="_blank" style={{ textDecoration: 'none', color: '#555' }}>
                                                <span className="d-flex align-items-center">
                                                    <em className="fa fa-globe"></em>&nbsp;&nbsp;&nbsp;
                                                    <span className="text-sm">Legacy Equip Setup</span>
                                                </span>
                                            </a>
                            
                                        </ListGroupItem> */}
                                        {
                                            this.state.reportAddress?.appSettingValue != "" ?
                                                <ListGroupItem action tag="div" href="" >
                                                    <a href={this.state.reportAddress} target="_blank" style={{ textDecoration: 'none', color: '#555' }}>
                                                        <span className="d-flex align-items-center">
                                                            <em className="fa fa-archive"></em>&nbsp;&nbsp;&nbsp;
                                                            <span className="text-sm">Report Portal</span>
                                                        </span>
                                                    </a>
                                                    {/* <Link target="_blank" to={this.state.dataSetting[3]?.appSettingValue} style={{ textDecoration: 'none', color: '#555' }}>
                                                        <span className="d-flex align-items-center">
                                                            <em className="fa fa-archive"></em>&nbsp;&nbsp;&nbsp;
                                                            <span className="text-sm">Report Portal</span>
                                                        </span>
                                                    </Link> */}
                                                </ListGroupItem>
                                                :
                                                null
                                        }
                                        {
                                            this.state.inventoryAddress?.appSettingValue != "" ?
                                                <ListGroupItem action tag="div" href="" >
                                                    <a href={this.state.inventoryAddress} target="_blank" style={{ textDecoration: 'none', color: '#555' }}>
                                                        <span className="d-flex align-items-center">
                                                            <em className="fa fa-address-book"></em>&nbsp;&nbsp;&nbsp;
                                                            <span className="text-sm">Inventory Portal</span>
                                                        </span>
                                                    </a>
                                                    {/* <Link to={this.state.dataSetting[2]?.appSettingValue} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#555' }}>
                                                        <span className="d-flex align-items-center">
                                                            <em className="fa fa-address-book"></em>&nbsp;&nbsp;&nbsp;
                                                            <span className="text-sm">Inventory Portal</span>
                                                        </span>
                                                    </Link> */}
                                                </ListGroupItem>
                                                :
                                                null
                                        }


                                        {this.state.topMenu?.map((menu, idx) => {
                                            return (
                                                <ListGroupItem action tag="div" href="" key={idx + 1} >
                                                <a href={this.formatRoute(menu.route)} target="_blank" style={{ textDecoration: 'none', color: '#555' }}>
                                                    <span className="d-flex align-items-center">
                                                        <em className="fa fa-address-book"></em>&nbsp;&nbsp;&nbsp;
                                                        <span className="text-sm">{menu.menuText}</span>
                                                    </span>
                                                </a>
                                                {/* <Link to={this.state.dataSetting[2]?.appSettingValue} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#555' }}>
                                                    <span className="d-flex align-items-center">
                                                        <em className="fa fa-address-book"></em>&nbsp;&nbsp;&nbsp;
                                                        <span className="text-sm">Inventory Portal</span>
                                                    </span>
                                                </Link> */}
                                                </ListGroupItem>
                                            )
                                        })}
                                        <ListGroupItem action tag="a" href="" onClick={this.handleLogout}>
                                            <span className="d-flex align-items-center">
                                                <em className="fa fa-sign-out-alt"></em>&nbsp;&nbsp;&nbsp;
                                                <span className="text-sm">Logout</span>
                                            </span>
                                        </ListGroupItem>
                                    </ListGroup>
                                    { /* END list group */}
                                </DropdownItem>
                            </DropdownMenu>
                            { /* END Dropdown menu */}
                        </UncontrolledDropdown>
                        { /* END Alert menu */}
                        { /* START Offsidebar button */}
                        {/* <li className="nav-item">
                            <a className="nav-link" href="" onClick={this.toggleOffsidebar}>
                                <em className="icon-notebook"></em>
                            </a>
                        </li> */}
                        { /* END Offsidebar menu */}
                    </ul>
                    { /* END Right Navbar */}

                    { /* START Search form */}
                    <form className="navbar-form" role="search" action="search.html">
                        <div className="form-group">
                            <input className="form-control" type="text" placeholder="Type and hit enter ..." />
                            <div className="fa fa-times navbar-form-close" data-search-dismiss=""></div>
                        </div>
                        <button className="d-none" type="submit">Submit</button>
                    </form>
                    { /* END Search form */}
                </nav>
                { /* END Top Navbar */}
            </header >
        );
    }

}

Header.propTypes = {
    actions: PropTypes.object,
    settings: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = state => ({ settings: state.settings, user: state.user.userInfo })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);